module.exports = __webpack_public_path__ + "static/media/review-applicants.c2151b97.svg";